/** Widget UI settings tabs in display order; the `?tab=` search param accepts the same values. */
export const SETTINGS_TABS = [
  "branding",
  "launcher",
  "messages",
  "popups",
  "banners",
  "advanced",
] as const;

export type SettingsTab = (typeof SETTINGS_TABS)[number];

export const DEFAULT_SETTINGS_TAB: SettingsTab = "branding";

/** Returns the tab named by an untrusted value, or undefined when it is not a settings tab. */
export function parseSettingsTab(value: unknown): SettingsTab | undefined {
  return typeof value === "string" && (SETTINGS_TABS as readonly string[]).includes(value)
    ? (value as SettingsTab)
    : undefined;
}
